import React, { useState, useEffect } from "react";
import {
  Button,
  Input,
  Select,
  Switch,
  Divider,
  ColorPicker,
  Upload,
  Row,
  Col,
  Collapse,
  Checkbox,
  TimePicker,
} from "antd";
import {
  CheckOutlined,
  CloseOutlined,
  CaretRightOutlined,
} from "@ant-design/icons";
import { UploadOutlined, DeleteOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { uploadImage } from "../../../../utils/utility";
import { useProjectState } from "../../../../context/stateContext";
import "../../AdminOrganizationsComponent/index.css";
import "./index.css";

const EditTabsMyMenuSettings = ({ sendMyMenuState, organization }) => {
  const [modes, setModes] = useState(null);
  const [discountsEnabled, setDiscountsEnabled] = useState(null);
  const [groupByOrderTime, setGroupByOrderTime] = useState(null);
  const [showAllergensFilter, setShowAllergensFilter] = useState(null);
  const [showAccount, setShowAccount] = useState(null);
  const [geocodingEnabled, setGeocodingEnabled] = useState(null);
  const [reviewsEnabled, setReviewsEnabled] = useState(null);
  const [surveyEnabled, setSurveyEnabled] = useState(null);
  const [reviewUrl, setReviewUrl] = useState(null);
  const [headerImageUrl, setHeaderImageUrl] = useState(null);
  const [longtitude, setLongtitude] = useState(null);
  const [latitude, setLatitude] = useState(null);
  const [radiusInMeters, setRadiusInMeters] = useState(null);
  const [textUpperCase, setTextUpperCase] = useState(null);
  const [onlyRegisteredUsers, setOnlyRegisteredUsers] = useState(null);
  const [autoExpandCategories, setAutoExpandCategories] = useState(null);
  const [favoriteItemsEnabled, setFavoriteItemsEnabled] = useState(null);
  const [autoExpandModifiers, setAutoExpandModifiers] = useState();
  const [menuItemsLayout, setMenuItemsLayout] = useState(null);
  const [menuCategoriesMode, setMenuCategoriesMode] = useState(null);
  const [currency, setCurrency] = useState(null);
  const [defaultLanguage, setDefaultLanguage] = useState(null);
  const [supportedLanguages, setSupportedLagnuages] = useState(null);
  const [rootCategoryId, setRootCategoryId] = useState(null);
  const [marketingAgreementURL, setMarketingAgreementURL] = useState(null);
  const [termsOfUseUrl, setTermsOfUseUrl] = useState(null);
  const [privacyAndPolicyAgreementURL, setPrivacyAndPolicyAgreementURL] =
    useState(null);
  const [logo, setLogo] = useState(null);
  const [backgroundImage, setBackgroundImage] = useState(null);
  const [advertBanner, setAdvertBanner] = useState(null);
  const [mainColor, setMainColor] = useState(null);
  const [backgroundColor, setBackgroundColor] = useState(null);
  const [headerFooterBackgroudColor, setHeaderFooterBackgroudColor] =
    useState(null);
  const [cardBackgroundColor, setCardBackgroundColor] = useState(null);
  const [otherElementsColor, setOtherElementsColor] = useState(null);
  const [secondaryButtonColor, setSecondaryButtonColor] = useState(null);
  const [textColor, setTextColor] = useState(null);
  const [actionButtonTextColor, setActionButtonTextColor] = useState(null);
  const [countryCode, setCountryCode] = useState(null);
  const [workingHours, setWorkingHours] = useState([]);
  const { menuCategories } = useSelector((state) => state.usersReducer);
  const { openEditOrganizationModal } = useProjectState();

  const myMenuState = {
    modes,
    discountsEnabled,
    groupByOrderTime,
    showAllergensFilter,
    showAccount,
    geocodingEnabled,
    textUpperCase,
    onlyRegisteredUsers,
    autoExpandCategories,
    favoriteItemsEnabled,
    autoExpandModifiers,
    menuItemsLayout,
    menuCategoriesMode,
    currency,
    defaultLanguage,
    supportedLanguages,
    rootCategoryId,
    marketingAgreementURL,
    termsOfUseUrl,
    privacyAndPolicyAgreementURL,
    logo,
    backgroundImage,
    advertBanner,
    mainColor,
    backgroundColor,
    headerFooterBackgroudColor,
    cardBackgroundColor,
    otherElementsColor,
    secondaryButtonColor,
    textColor,
    actionButtonTextColor,
    countryCode,
    reviewsEnabled,
    surveyEnabled,
    reviewUrl,
    workingHours,
    headerImageUrl,
  };

  myMenuState.radiusInMeters = radiusInMeters || 0;
  myMenuState.longtitude = longtitude || 0;
  myMenuState.latitude = latitude || 0;

  useEffect(() => {
    sendMyMenuState(myMenuState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(myMenuState)]);

  useEffect(() => {
    setModes(organization?.myMenuConfiguration?.modes);
    setDiscountsEnabled(
      organization?.myMenuConfiguration?.orderingConfiguration.discountsEnabled
    );
    setGroupByOrderTime(organization?.myMenuConfiguration?.groupByOrderTime);
    setShowAllergensFilter(
      organization?.myMenuConfiguration?.showAllergensFilter
    );
    setShowAccount(organization?.myMenuConfiguration?.showAccount);
    setFavoriteItemsEnabled(
      organization?.myMenuConfiguration?.favoriteItemsEnabled
    );
    setAutoExpandModifiers(
      organization?.myMenuConfiguration?.autoExpandModifiers
    );
    setGeocodingEnabled(
      organization?.myMenuConfiguration?.orderingConfiguration?.geocodingEnabled
    );
    setReviewsEnabled(organization?.myMenuConfiguration?.reviewsEnabled);
    setSurveyEnabled(organization?.myMenuConfiguration?.surveyEnabled);
    setReviewUrl(organization?.myMenuConfiguration?.reviewUrl);
    setHeaderImageUrl(organization?.myMenuConfiguration?.headerImageUrl);
    setTextUpperCase(organization?.myMenuConfiguration?.textUpperCase);
    setOnlyRegisteredUsers(
      organization?.myMenuConfiguration?.onlyRegisteredUsers
    );
    setRootCategoryId(organization?.myMenuConfiguration?.rootCategoryId);
    setAutoExpandCategories(
      organization?.myMenuConfiguration?.autoExpandCategories
    );
    setLongtitude(
      organization?.myMenuConfiguration?.orderingConfiguration?.longtitude
    );
    setLatitude(
      organization?.myMenuConfiguration?.orderingConfiguration?.latitude
    );
    setRadiusInMeters(
      organization?.myMenuConfiguration?.orderingConfiguration?.radiusInMeters
    );
    setMenuItemsLayout(organization?.myMenuConfiguration?.menuItemsLayout);
    setMenuCategoriesMode(
      organization?.myMenuConfiguration?.menuCategoriesMode
    );
    setCurrency(organization?.myMenuConfiguration?.currency);
    setDefaultLanguage(organization?.myMenuConfiguration?.defaultLanguage);
    setSupportedLagnuages(organization?.myMenuConfiguration?.languages);
    setMarketingAgreementURL(
      organization?.myMenuConfiguration?.marketingAgreementURL
    );
    setTermsOfUseUrl(organization?.myMenuConfiguration?.termsOfUseUrl);
    setPrivacyAndPolicyAgreementURL(
      organization?.myMenuConfiguration?.privacyAndPolicyAgreementURL
    );
    setLogo(organization?.myMenuConfiguration?.logo);
    setBackgroundImage(organization?.myMenuConfiguration?.backgroundImage);
    setAdvertBanner(organization?.myMenuConfiguration?.advertBanner);
    setMainColor(organization?.myMenuConfiguration?.theme?.mainColor);
    setBackgroundColor(
      organization?.myMenuConfiguration?.theme?.backgroundColor
    );
    setHeaderFooterBackgroudColor(
      organization?.myMenuConfiguration?.theme?.headerFooterBackgroudColor
    );
    setCardBackgroundColor(
      organization?.myMenuConfiguration?.theme?.cardBackgroundColor
    );
    setOtherElementsColor(
      organization?.myMenuConfiguration?.theme?.otherElementsColor
    );
    setSecondaryButtonColor(
      organization?.myMenuConfiguration?.theme?.secondaryButtonColor
    );
    setTextColor(organization?.myMenuConfiguration?.theme?.textColor);
    setActionButtonTextColor(
      organization?.myMenuConfiguration?.theme?.actionButtonTextColor
    );
    setCountryCode(organization?.myMenuConfiguration?.countryCode);
    setWorkingHours(organization?.myMenuConfiguration?.workingHours);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organization, openEditOrganizationModal]);

  const layoutOptions = [
    { value: 0, label: "Със снимки" },
    { value: 1, label: "Списък" },
  ];

  const menuCategoriesModeOptions = [
    { value: 0, label: "Отделен бутон" },
    { value: 1, label: "Основна страница" },
  ];

  const currencyOptions = [
    { value: "лв.", label: "лв." },
    { value: "$", label: "$" },
    { value: "€", label: "€" },
    { value: "£", label: "£" },
    { value: "RON", label: "RON" },
  ];

  const defaultLanguageOptions = [
    { value: "bg", label: "Български" },
    { value: "en", label: "Английски" },
  ];

  const organizationModes = [
    { value: 2, label: "Ordering" },
    { value: 1, label: "Delivery" },
    { value: "Ordering + Delivery", label: "Ordering + Delivery" },
    { value: 0, label: "Payment" },
    { value: 3, label: "RoomService" },
  ];

  const supportedLanguagesOptions = [
    { label: "Български", value: "bg" },
    { label: "Английски", value: "en" },
    { label: "Румънски", value: "ro" },
    { label: "Руски", value: "ru" },
    { label: "Украински", value: "ua" },
  ];

  const rootCategoriesIdArray = menuCategories.map((item, index) => {
    return { key: index, value: item.key, label: item.value };
  });

  const defaultRootCategoryIdOptions = [
    { value: null, label: "Без основна категория" },
    ...rootCategoriesIdArray,
  ];
  const resetColorPickersToDefault = () => {
    setBackgroundColor("#f0f2f5");
    setHeaderFooterBackgroudColor("#fff");
    setCardBackgroundColor("#ffffff");
    setOtherElementsColor("#d9d9d9");
    setSecondaryButtonColor("#ffffff");
    setTextColor("#000");
    setActionButtonTextColor("#fff");
  };

  const onChangeWorkingHours = (daysFromWeek) => {
    setWorkingHours((prevWorkingHours) =>
      prevWorkingHours.map((item, index) => {
        // If the current dayOfWeek is in the checked daysFromWeek array
        if (daysFromWeek.includes(item.dayOfWeek.toString())) {
          // Set isActive to true
          return { ...item, isActive: true, key: index };
        } else {
          // Otherwise, set isActive to false
          return { ...item, isActive: false, key: index };
        }
      })
    );
  };

  const handleTimeChange = (dayOfWeek, time) => {
    const [startTime, endTime] = time;
    setWorkingHours((prevWorkingHours) =>
      prevWorkingHours.map((item) => {
        if (item.dayOfWeek === dayOfWeek) {
          return {
            ...item,
            startTime: startTime
              ? startTime.format("YYYY-MM-DDTHH:mm:ss")
              : item.startTime,
            endTime: endTime
              ? endTime.format("YYYY-MM-DDTHH:mm:ss")
              : item.endTime,
          };
        }
        return item;
      })
    );
  };

  // Sort working hours
  workingHours.sort((a, b) => a.dayOfWeek - b.dayOfWeek);

  return (
    <>
      <label className="admin-organization-edit-input-label admin-organization-lable-input-width">
        Режими на работа
        <span className="admin-organization-input-label-require">*</span>
      </label>
      <Select
        className="admin-organization-edit-mymenu-select-modes"
        allowClear
        value={modes?.length === 2 ? "Ordering + Delivery" : modes}
        placeholder="Please select"
        onChange={(value) => setModes(value)}
        options={organizationModes}
      />
      <Divider></Divider>

      <div className="admin-organization-edit-sections">
        <div className="admin-organization-edit-mymenu-settings-row">
          <label className="admin-organization-edit-input-label admin-organization-lable-input-width">
            Отсъпки
          </label>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={discountsEnabled}
            onChange={(value) => setDiscountsEnabled(value)}
          />
        </div>
        <div className="admin-organization-edit-mymenu-settings-row">
          <label className="admin-organization-edit-input-label admin-organization-lable-input-width">
            Само главни букви
          </label>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={textUpperCase}
            onChange={(value) => setTextUpperCase(value)}
          />
        </div>
      </div>
      <div className="admin-organization-edit-sections">
        <div className="admin-organization-edit-mymenu-settings-row">
          <label className="admin-organization-edit-input-label admin-organization-lable-input-width">
            Групиране в сметка по време
          </label>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={groupByOrderTime}
            onChange={(value) => setGroupByOrderTime(value)}
          />
        </div>
        <div className="admin-organization-edit-mymenu-settings-row">
          <label className="admin-organization-edit-input-label admin-organization-lable-input-width">
            Само регистрирани потребители
          </label>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={onlyRegisteredUsers}
            onChange={(value) => setOnlyRegisteredUsers(value)}
          />
        </div>
      </div>
      <div className="admin-organization-edit-sections">
        <div className="admin-organization-edit-mymenu-settings-row">
          <label className="admin-organization-edit-input-label admin-organization-lable-input-width">
            Показване на филтер алергени
          </label>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={showAllergensFilter}
            onChange={(value) => setShowAllergensFilter(value)}
          />
        </div>
        <div className="admin-organization-edit-mymenu-settings-row">
          <label className="admin-organization-edit-input-label admin-organization-lable-input-width">
            Автоматично разгъване на категории
          </label>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={autoExpandCategories}
            onChange={(value) => setAutoExpandCategories(value)}
          />
        </div>
      </div>
      <div className="admin-organization-edit-sections">
        <div className="admin-organization-edit-mymenu-settings-row">
          <label className="admin-organization-edit-input-label admin-organization-lable-input-width">
            Показване на акаунт
          </label>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={showAccount}
            onChange={(value) => setShowAccount(value)}
          />
        </div>
        <div className="admin-organization-edit-mymenu-settings-row">
          <label className="admin-organization-edit-input-label admin-organization-lable-input-width">
            Показване на любими ястия
          </label>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={favoriteItemsEnabled}
            onChange={(value) => setFavoriteItemsEnabled(value)}
          />
        </div>
      </div>
      <div className="admin-organization-edit-sections">
        <div className="admin-organization-edit-mymenu-settings-row">
          <label className="admin-organization-edit-input-label admin-organization-lable-input-width">
            Геолокация
          </label>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={geocodingEnabled}
            onChange={(value) => {
              setGeocodingEnabled(value);
            }}
          />
        </div>
        <div className="admin-organization-edit-mymenu-settings-row">
          <label className="admin-organization-edit-input-label admin-organization-lable-input-width">
            Google Анкети
          </label>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={reviewsEnabled}
            onChange={(value) => {
              setReviewsEnabled(value);
            }}
          />
        </div>
      </div>
      <div className="admin-organization-edit-sections">
        <div className="admin-organization-edit-mymenu-settings-row">
          <label className="admin-organization-edit-input-label admin-organization-lable-input-width">
            Скриване на коментари в клик
          </label>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={autoExpandModifiers}
            onChange={(value) => setAutoExpandModifiers(value)}
          />
        </div>
        <div className="admin-organization-edit-mymenu-settings-row">
          <label className="admin-organization-edit-input-label admin-organization-lable-input-width">
            Portal Анкети
          </label>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={surveyEnabled}
            onChange={(value) => {
              setSurveyEnabled(value);
            }}
          />
        </div>
      </div>
      <div className="admin-organization-edit-sections">
        <div className="admin-organization-edit-mymenu-settings-row">
          <Collapse
            expandIcon={({ isActive }) => (
              <CaretRightOutlined rotate={isActive ? 90 : 0} />
            )}
            ghost
            items={[
              {
                key: "1",
                label: (
                  <label className="admin-organization-edit-input-label admin-organization-lable-input-width">
                    Работно време
                  </label>
                ),
                children: (
                  <Checkbox.Group
                    onChange={onChangeWorkingHours}
                    value={workingHours
                      .filter((daysFromWeek) => daysFromWeek.isActive) // Filter only active days
                      .map((daysFromWeek) => daysFromWeek.dayOfWeek.toString())}
                  >
                    <Row>
                      {workingHours.map((daysFromWeek, index) => (
                        <Col
                          key={daysFromWeek.dayOfWeek + index}
                          span={24}
                          className="admin-organization-working-hours-time-picker"
                        >
                          <Checkbox value={daysFromWeek.dayOfWeek.toString()}>
                            {daysFromWeek.dayOfWeek === 0
                              ? "Неделя"
                              : daysFromWeek.dayOfWeek === 1
                              ? "Понеделник"
                              : daysFromWeek.dayOfWeek === 2
                              ? "Вторник"
                              : daysFromWeek.dayOfWeek === 3
                              ? "Сряда"
                              : daysFromWeek.dayOfWeek === 4
                              ? "Четвъртък"
                              : daysFromWeek.dayOfWeek === 5
                              ? "Петък"
                              : "Събота"}
                          </Checkbox>
                          <TimePicker.RangePicker
                            className="admin-organization-working-hours-time-picker-dropdown"
                            value={[
                              dayjs(
                                workingHours.find(
                                  (item) =>
                                    item.dayOfWeek === daysFromWeek.dayOfWeek
                                )?.startTime
                              ),
                              dayjs(
                                workingHours.find(
                                  (item) =>
                                    item.dayOfWeek === daysFromWeek.dayOfWeek
                                )?.endTime
                              ),
                            ]}
                            format="HH:mm"
                            disabled={!daysFromWeek.isActive}
                            onChange={(time) =>
                              handleTimeChange(daysFromWeek.dayOfWeek, time)
                            }
                          />
                        </Col>
                      ))}
                    </Row>
                  </Checkbox.Group>
                ),
              },
            ]}
          />
        </div>
      </div>

      {geocodingEnabled && (
        <div className="admin-organization-edit-sections">
          <div className="admin-organization-full-width">
            <label className="admin-organization-edit-input-label">
              Latitude
            </label>
            <Input
              value={latitude}
              onChange={(e) => setLatitude(e.target.value)}
            />
          </div>
          <div className="admin-organization-full-width">
            <label className="admin-organization-edit-input-label">
              Longtitude
            </label>
            <Input
              value={longtitude}
              onChange={(e) => setLongtitude(e.target.value)}
            />
          </div>
          <div className="admin-organization-full-width">
            <label className="admin-organization-edit-input-label">
              RadiusInMeters
            </label>
            <Input
              value={radiusInMeters}
              onChange={(e) => setRadiusInMeters(e.target.value)}
            />
          </div>
        </div>
      )}
      {reviewsEnabled && (
        <div className="admin-organization-edit-sections">
          <div className="admin-organization-full-width">
            <label className="admin-organization-edit-input-label">
              Google Анкети url
            </label>
            <Input
              value={reviewUrl}
              onChange={(e) => setReviewUrl(e.target.value)}
            />
          </div>
        </div>
      )}
      <div className="admin-organization-edit-sections">
        <div className="admin-organization-full-width">
          <label className="admin-organization-edit-input-label">
            Header image url
          </label>
          <Input
            value={headerImageUrl}
            onChange={(e) => setHeaderImageUrl(e.target.value)}
          />
        </div>
      </div>

      <Divider></Divider>
      <div className="admin-organization-edit-sections">
        <div className="admin-organization-full-width">
          <label className="admin-organization-edit-input-label">
            Изглед на менюто
          </label>
          <Select
            className="admin-organization-full-width"
            value={menuItemsLayout}
            options={layoutOptions}
            onChange={(value) => setMenuItemsLayout(value)}
          />
        </div>
        <div className="admin-organization-full-width">
          <label className="admin-organization-edit-input-label">
            Снимки на групи
          </label>
          <Select
            className="admin-organization-full-width"
            value={menuCategoriesMode}
            options={menuCategoriesModeOptions}
            onChange={(value) => setMenuCategoriesMode(value)}
          />
        </div>
        <div className="admin-organization-full-width">
          <label className="admin-organization-edit-input-label">Валута</label>
          <Select
            className="admin-organization-full-width"
            value={currency}
            options={currencyOptions}
            onChange={(value) => setCurrency(value)}
          />
        </div>
      </div>

      <div className="admin-organization-edit-sections">
        <div className="admin-organization-full-width">
          <label className="admin-organization-edit-input-label">
            Основен език
          </label>
          <Select
            className="admin-organization-full-width"
            value={defaultLanguage}
            options={defaultLanguageOptions}
            onChange={(value) => setDefaultLanguage(value)}
          />
        </div>
        <div className="admin-organization-full-width">
          <label className="admin-organization-edit-input-label">
            Поддържани езици
          </label>
          <Select
            mode="multiple"
            className="admin-organization-full-width"
            value={supportedLanguages}
            options={supportedLanguagesOptions}
            onChange={(value) => setSupportedLagnuages(value)}
          />
        </div>
        <div className="admin-organization-full-width">
          <label className="admin-organization-edit-input-label">
            Основна категория
          </label>
          <Select
            showSearch
            className="admin-organization-full-width"
            value={rootCategoryId}
            placeholder="Основна категория"
            options={defaultRootCategoryIdOptions}
            onChange={(value) => {
              setRootCategoryId(value);
            }}
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
          />
        </div>
      </div>

      <div className="admin-organization-edit-sections">
        <div className="admin-organization-full-width">
          <label className="admin-organization-edit-input-label">
            Reклaмни съобщения
          </label>
          <Input
            value={marketingAgreementURL}
            onChange={(e) => setMarketingAgreementURL(e.target.value)}
          />
        </div>
        <div className="admin-organization-full-width">
          <label className="admin-organization-edit-input-label">
            Условия за ползване
          </label>
          <Input
            value={termsOfUseUrl}
            onChange={(e) => setTermsOfUseUrl(e.target.value)}
          />
        </div>
        <div className="admin-organization-full-width">
          <label className="admin-organization-edit-input-label">
            Политика за поверителност
          </label>
          <Input
            value={privacyAndPolicyAgreementURL}
            onChange={(e) => setPrivacyAndPolicyAgreementURL(e.target.value)}
          />
        </div>
      </div>

      <Divider />

      <div className="admin-organization-edit-sections">
        <div className="admin-organization-full-width">
          <p className="admin-organization-image-text">Лого</p>
          <img
            src={`data:image/jpeg;base64,${logo?.substring(
              logo?.indexOf(",") + 1
            )}`}
            className="admin-organization-uploaded-image"
            alt="logo"
          />
          <div className="admin-organization-edit-upload-image-container">
            <Upload
              showUploadList={false}
              onChange={(e) => uploadImage(e, setLogo)}
              accept="image/png,image/jpeg,image/webp"
              beforeUpload={() => false}
            >
              <Button
                className="admin-organization-upload-button"
                type="primary"
                icon={<UploadOutlined />}
                size="large"
              >
                Качи файл
              </Button>
            </Upload>
          </div>
        </div>
        <div className="admin-organization-full-width">
          <p className="admin-organization-image-text">Фон</p>
          <img
            src={`data:image/png;base64, ${backgroundImage?.substring(
              backgroundImage?.indexOf(",") + 1
            )}`}
            alt="backgroundImage"
            className="admin-organization-uploaded-image"
          />
          <div className="admin-organization-edit-upload-image-container">
            <Upload
              showUploadList={false}
              onChange={(e) => uploadImage(e, setBackgroundImage)}
              accept="image/png,image/jpeg,image/webp"
              beforeUpload={() => false}
            >
              <Button
                className="admin-organization-upload-button"
                type="primary"
                icon={<UploadOutlined />}
                size="large"
              >
                Качи файл
              </Button>
            </Upload>
          </div>
        </div>
      </div>
      <div className="admin-organization-edit-sections">
        <div className="admin-organization-full-width">
          <p className="admin-organization-image-text">Рекламен банер</p>
          {advertBanner && (
            <img
              src={`data:image/png;base64, ${advertBanner?.substring(
                advertBanner?.indexOf(",") + 1
              )}`}
              alt="advertBannerImage"
              className="admin-organization-uploaded-image"
            />
          )}
          <div
            className="admin-organization-edit-upload-image-container"
            style={{ gap: "10px" }}
          >
            <Upload
              showUploadList={false}
              onChange={(e) => uploadImage(e, setAdvertBanner)}
              accept="image/png,image/jpeg,image/webp"
              beforeUpload={() => false}
            >
              <Button
                className="admin-organization-upload-button"
                type="primary"
                icon={<UploadOutlined />}
                size="large"
              >
                Качи файл
              </Button>
            </Upload>
            {advertBanner && (
              <Button size="large" onClick={() => setAdvertBanner(null)}>
                <DeleteOutlined />
              </Button>
            )}
          </div>
        </div>
      </div>
      <Divider />
      <Row justify="center">
        <Col
          className="edit-organization-colorpicker-col"
          xs={24}
          sm={12}
          md={10}
          lg={8}
          xl={6}
        >
          <p className="edit-organization-colorpicker-text">Main Color</p>
          <ColorPicker
            showText
            value={mainColor}
            onChange={(value) => setMainColor(value.toHexString())}
          />
        </Col>
        <Col
          className="edit-organization-colorpicker-col"
          xs={24}
          sm={12}
          md={10}
          lg={8}
          xl={6}
        >
          <p className="edit-organization-colorpicker-text">Background Color</p>
          <ColorPicker
            showText
            value={backgroundColor}
            onChange={(value) => setBackgroundColor(value.toHexString())}
          />
        </Col>
        <Col
          className="edit-organization-colorpicker-col"
          xs={24}
          sm={12}
          md={10}
          lg={8}
          xl={6}
        >
          <p className="edit-organization-colorpicker-text">
            headerFooterBackgroudColor
          </p>
          <ColorPicker
            showText
            value={headerFooterBackgroudColor}
            onChange={(value) =>
              setHeaderFooterBackgroudColor(value.toHexString())
            }
          />
        </Col>
        <Col
          className="edit-organization-colorpicker-col"
          xs={24}
          sm={12}
          md={10}
          lg={8}
          xl={6}
        >
          <p className="edit-organization-colorpicker-text">
            cardBackgroundColor
          </p>
          <ColorPicker
            showText
            value={cardBackgroundColor}
            onChange={(value) => setCardBackgroundColor(value.toHexString())}
          />
        </Col>
        <Col
          className="edit-organization-colorpicker-col"
          xs={24}
          sm={12}
          md={10}
          lg={8}
          xl={6}
        >
          <p className="edit-organization-colorpicker-text">
            otherElementsColor
          </p>
          <ColorPicker
            showText
            value={otherElementsColor}
            onChange={(value) => setOtherElementsColor(value.toHexString())}
          />
        </Col>
        <Col
          className="edit-organization-colorpicker-col"
          xs={24}
          sm={12}
          md={10}
          lg={8}
          xl={6}
        >
          <p className="edit-organization-colorpicker-text">
            secondaryButtonColor
          </p>
          <ColorPicker
            showText
            value={secondaryButtonColor}
            onChange={(value) => setSecondaryButtonColor(value.toHexString())}
          />
        </Col>
        <Col
          className="edit-organization-colorpicker-col"
          xs={24}
          sm={12}
          md={10}
          lg={8}
          xl={6}
        >
          <p className="edit-organization-colorpicker-text">textColor</p>
          <ColorPicker
            showText
            value={textColor}
            onChange={(value) => setTextColor(value.toHexString())}
          />
        </Col>
        <Col
          className="edit-organization-colorpicker-col"
          xs={24}
          sm={12}
          md={10}
          lg={8}
          xl={6}
        >
          <p className="edit-organization-colorpicker-text">
            ActionButtonColor
          </p>
          <ColorPicker
            showText
            value={actionButtonTextColor}
            onChange={(value) => setActionButtonTextColor(value.toHexString())}
          />
        </Col>
      </Row>
      <Row className="admin-organization-edit-mymenu-reset-colors-row">
        <Col
          className="edit-organization-colorpicker-col"
          xs={24}
          sm={24}
          md={24}
          lg={24}
          xl={9}
        >
          <Button
            className="admin-organization-edit-mymenu-reset-colors-button"
            type="primary"
            ghost
            onClick={resetColorPickersToDefault}
          >
            Връщане на основните цветове
          </Button>
        </Col>
      </Row>
      <Divider />
    </>
  );
};

export default EditTabsMyMenuSettings;
